import styles from './Dashboard.module.css';
import '../../resources/css/admin_style.css';
import React, {useEffect, useRef, useState} from "react";
import Loading from "../../utils/loading/Loading";
import Header from '../Header/Header';
import NavBar, {NavType} from "../NavBar/NavBar";
import {IAM_PATH, IAM_SERVER_SERVICE_ACOUNT, IAM_SERVER_SERVICE_PRODUCT} from "../../utils/Config";
import axios from "../../utils/api/axios";
import ExpirationUserTable from './component/ExpirationUserTable';
import {CircularProgress} from "@mui/material";
import {Doughnut, Line} from "react-chartjs-2";
import { DialogEnum, showDialog } from '../../utils/dialog/Dialog';

/**
 * 대시보드 화면
 * @param callback
 * @param delay
 */
function Dashboard({setMovePage, groupId}) {

    const [loading, setLoading] = useState(false);
    const [dashTopData, setDashTopData] = useState({
        totalCount: 0, activeCount: 0, deactiveCount: 0, expirationCount:0
    }); //사용자 통계
    const [tokenChartData, setTokenChartData] = useState(null); //액세스토큰 24시간 그래프
    const [ServiceUsersChartdata, setServiceUsersChartdata] = useState(null); //서비스유저 통계

    useEffect(() => {
        setMovePage("dashboard");
        fetchTotalUserData();
    }, []);

    const fetchTotalUserData = () => {
        const params = {
            startDate: 0,
            endDate: 0,
            sortField : [],
            sortOrder : [],
            operator: "",
            conditions : [],
            page : 0,
            size : 10,
            groupByFields : ["status"]
        }

        const url = IAM_PATH + IAM_SERVER_SERVICE_ACOUNT + "/groupby";
        axios.post(url, params)
            .then((res) => {
                let activeCount = 0;
                let deactiveCount = 0;
                let expirationCount = 0;

                res.data.data.data.forEach(item => {
                switch (item.status) {
                    case 'active':
                    activeCount = item.count;
                    break;
                    case 'deactive':
                    deactiveCount = item.count;
                    break;
                    case 'expiration':
                    expirationCount = item.count;
                    break;
                }
                });
                setDashTopData(prev => ({
                    ...prev,
                    totalCount: activeCount + deactiveCount + expirationCount,
                    activeCount,
                    deactiveCount,
                    expirationCount
                }));
            })
            .catch((e) => {
                console.error(e)
            })
            .finally(() => {
                setLoading(false);
            })
    }

    // 서비스 유저 통계 조회 API Response Data 처리
    const processServiceUsersChartData = (data) => {
        const labelArray = [];
        const countArray = [];
        for (const chartData of data) {
            labelArray.push(chartData.linkServiceId);
            countArray.push(chartData.userCount);
        }

        const graphData = {
            labels: labelArray.length === 0 ? [] : labelArray,
            datasets: [{
                label: '서비스 사용자 통계',
                data: countArray ?? [],
            }]
        }

        setServiceUsersChartdata(graphData);
    }

    //------------------------------------
    const [page, setPage] = useState(0);
    const listSize = 10;
    const [totalCount, setTotalCount] = useState(0);

    const [isMobileWindow, setIsMobileWindow] = useState(false);
    useEffect(() => {
        const handleResize = () => {
        setIsMobileWindow(window.innerWidth < 768); // 모바일 기준 너비
    };
        handleResize(); // 초기값
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    //상품 목록 조회
    const [products, setProducts] = useState([]);
    const [idToNameMap, setIdToNameMap] = useState({});
    useEffect(() => {
        const fetchGroups  = async () => {
            const map = await getProducts();  // map 반환 받기
            setIdToNameMap(map); // 비동기적으로 idToNameMap 설정
        };
        fetchGroups ();
    }, []);

    useEffect(() => {
        // idToNameMap이 비어있지 않을 때만 fetchData 실행
        if (Object.keys(idToNameMap).length > 0) {
            // fetchData();  // 인자 없이 idToNameMap 직접 참조
        }
    }, [idToNameMap]);

    const getProducts = async () => {
        const param = {
            startDate: 0,
            endDate: 0,
            page: 0,
            size: -1,
            sortField: [],
            sortOrder: [],
            operator: "",
            conditions: []
        };

        const url = IAM_PATH + IAM_SERVER_SERVICE_PRODUCT + "/products";
        const res = await axios.post(url, param);
        const { data } = res.data;

        // 객체 순회
        const groupList = [];
        const map = {};

        Object.entries(data).forEach(([productId, productData]) => {
            const productObj = {
                id: productId,          // 제품 ID (key)
                name: productData.name, // 제품명
                plans: productData.plans // 요금제 배열
            };

            groupList.push(productObj);
            map[productId] = productObj; // 모든 정보 포함된 객체를 맵에 저장
        });

        setProducts(groupList);     // [{ id: "35", name: "2", plans: [...] }, ...]
        setIdToNameMap(map); 
        return map; // ← map 반환
    };

    useEffect(() => {
        getGroupUsersAll(groupId, page, listSize);
        
    }, [page]);

    const handleNextPage = () => {
        setPage((prevPage) => {
            const newPage = prevPage + 1;
            return newPage;
        });
    };

    const handlePrevPage = () => {
        setPage((prevPage) => {
            const newPage = Math.max(prevPage - 1, 0);
            return newPage;
        });
    };
    
    const [selectedGroupUsers, setSelectedGroupUsers] = useState([]);

    const today = new Date();
    const timestamp = today.getTime(); // 현재 시간 (ms)
    const tenDaysLaterTimestamp = timestamp + (10 * 24 * 60 * 60 * 1000); // 10일치 밀리초 더하기

    const getGroupUsersAll = async (groupId, page = 0, size=listSize) => {        
        const groupUsersAll = IAM_PATH + IAM_SERVER_SERVICE_ACOUNT + "/all";

        const conditions = []
        conditions.push({"field": "endDate", "operator": "GREATER_THAN_OR_EQUAL", "value": timestamp});
        conditions.push({"field": "endDate", "operator": "LESS_THAN_OR_EQUAL", "value": tenDaysLaterTimestamp});

        const params = {
            startDate: 0,
            endDate: 0,
            page: page,
            size: size,
            sortField : ["id"],
            sortOrder : ["desc"],
            operator: "AND",
            conditions: conditions
        };

        await axios.post(groupUsersAll, params)
            .then((res) => {
                setTotalCount(res.data.data.totalCount);
                setSelectedGroupUsers(res.data.data.data.map(item => ({ ...item })));
            })
            .catch((e) => {
                console.error(e);
                showDialog(DialogEnum.DEFAULT, "실패", "사용자 정보 조회에 실패했습니다.");
            })
            .finally(() => {
            });
    };

    return (
        <div className={"adminWrap"}>
            <NavBar type={NavType.DASH}/>
            {loading ? <Loading/> :
                <section className={"rightCont"}>
                    <Header/>
                    <div className={"rightCont__cont"}>

                        <div className={styles.rightCont__cont__situTop}>
                            <div className={`${styles.rightCont__cont__situBox} ${styles.totalUser}`}>
                                <p className={styles.rightCont__cont__cate}>전체</p>
                                <h3 className={`${styles.rightCont__cont__count} ${styles.totalUser}`}>{dashTopData.totalCount}</h3>
                            </div>
                            <div className={`${styles.rightCont__cont__situBox} ${styles.totalReg}`}>
                                <p className={styles.rightCont__cont__cate}>할당됨</p>
                                <h3 className={`${styles.rightCont__cont__count} ${styles.totalReg}`}>{dashTopData.activeCount}</h3>
                            </div>
                            <div className={`${styles.rightCont__cont__situBox} ${styles.totalUnReg}`}>
                                <p className={styles.rightCont__cont__cate}>미할당</p>
                                <h3 className={`${styles.rightCont__cont__count} ${styles.totalUnReg}`}>{dashTopData.deactiveCount}</h3>
                            </div>
                            <div className={`${styles.rightCont__cont__situBox} ${styles.totalExpir}`}>
                                <p className={styles.rightCont__cont__cate}>만료</p>
                                <h3 className={`${styles.rightCont__cont__count} ${styles.totalExpir}`}>{dashTopData.expirationCount}</h3>
                            </div>
                        </div>
                        <h2 className={styles.sectionTitle}>· 만료 예정</h2>
                        <div className={styles.rightCont__cont__dash}>
                            <div className={styles.rightCont__cont__tableWrap} style={{flex: "1"}}>
                                <div className={styles.permissionPanel}>
                                    <ExpirationUserTable
                                        users={selectedGroupUsers}
                                        onPrevPage={handlePrevPage}
                                        onNextPage={handleNextPage}
                                        disablePrev={page === 0}
                                        disableNext={(page + 1) * listSize >= totalCount}
                                        pageNumber={page}
                                        totalCount={totalCount}
                                        listSize={listSize}
                                        isMobileWindow={isMobileWindow}
                                        products={idToNameMap}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            }
        </div>
    )
}

export default Dashboard;